<script setup lang="ts">
import { useTemplateRef, type HTMLAttributes } from 'vue';
import { type BaseTextInputProps } from './internal';
import NxInputWrapper from './NxInputWrapper.vue';

const props = defineProps<
  BaseTextInputProps & { multiline?: boolean } & /* @vue-ignore */ Omit<HTMLAttributes, 'value'>
>();

defineOptions({ inheritAttrs: false });

const fakeInputRef = useTemplateRef('fake-input-ref');
defineExpose({ divElement: fakeInputRef });
</script>

<template>
  <NxInputWrapper v-bind="props" :multiline="props.multiline">
    <template #default="{ inputAttrs, textHidden }">
      <div
        ref="fake-input-ref"
        v-bind="{
          ...inputAttrs,
          ...$attrs,
          style: { ...inputAttrs.style, ...($attrs.style as {}) },
        }"
        :class="['fake-input', `height-${props.height ?? 's'}`, { 'text-hidden': textHidden }]"
      >
        <slot></slot>
      </div>
    </template>
  </NxInputWrapper>
</template>

<style scoped src="./style.css" />
<style scoped>
.text-hidden {
  color: transparent;
  user-select: none;
  pointer-events: none;
}
</style>
